<template>
  <v-app>
    <v-app-bar app color="secondary">
      <LoadingIdle
        v-if="isLogIn"
        @OnWarningTimeout="Logout()"
        :DialogText="SessionTimeoutWarning"
        :ButtonText="'Cancel'"
        :IdleTimeout="SessionIdleTimeout"
      ></LoadingIdle>
      <div class="d-flex align-center">
        <v-img
          alt="SCDMV Logo"
          class="shrink mr-2"
          contain
          src="@/assets/logo-dmv.svg"
          transition="scale-transition"
          width="120"
        />
      </div>
      <v-spacer></v-spacer>
      <!-- <div class="red--text">Not Official - Prototype Only</div> -->
      <div class="text-center mt-2 hidden-sm-and-down">
        <v-btn
          v-if="isLogIn"
          class="btn-logout text--upper"
          color="primary"
          @click="Logout()">
          Logout
          <v-icon>mdi-logout</v-icon>
        </v-btn>
        <div class="site-version">V-{{version}}</div>
      </div>
      <div
        class="hidden-md-and-up"
      >
        <v-menu
        bottom
        close-on-content-click
        origin="center center"
        transition="scale-transition"
        v-if="isLogIn"
        >
        <template v-slot:activator="{ on }">
          <v-app-bar-nav-icon @click.stop="showMenu = !showMenu" v-on="on"></v-app-bar-nav-icon>
        </template>
        <v-list>
          <v-list-item>
            <v-btn
              color="primary"
              class="button-sm text-upper"
              @click="Logout()"
              >Logout</v-btn
            >
          </v-list-item>
        </v-list>
      </v-menu>
      <div class="site-version mt-n3">V-{{version}}</div>
      </div>
    </v-app-bar>
    <v-main>
      <div class="white--text pa-1 d-print-none primary headerBackground">
        <div class="text-h6 appTitle">SCHEDULE A ROAD TEST</div>
      </div>
      <v-container class="container">
        <component
          :is="currentComponent"
          ref="child"
          :eligibilityData="eligibilityData"
          @navigateTo="navigateTo"
        />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LoginPage from './pages/LoginPage.vue';
import LandingPage from './pages/LandingPage.vue';
import CustomerDetailsPage from './pages/CustomerDetailsPage.vue';
import SelectLocation from './pages/SelectLocation.vue';
import SummaryPage from './pages/SummaryPage.vue';
import ConfirmationPage from './pages/ConfirmationPage.vue';
import ViewExistingPage from './pages/ViewExistingPage.vue';
import CancelAppointmentPage from './pages/CancelAppointmentPage.vue';
import CancelConfirmationPage from './pages/CancelConfirmationPage.vue';
import siteVersionInfo from './assets/SiteVersionInfo.json';
import SessionState from './models/SessionState';
import LoadingIdle from './components/LoadingIdle.vue';
import scApi from './api/scApi';

export default {
  name: 'App',

  components: {
    LoginPage,
    LandingPage,
    CustomerDetailsPage,
    SelectLocation,
    SummaryPage,
    ConfirmationPage,
    ViewExistingPage,
    CancelAppointmentPage,
    CancelConfirmationPage,
    LoadingIdle,
  },

  data() {
    return {
      currentComponent: 'LoginPage',
      eligibilityData: null,
      version: siteVersionInfo.VersionNumber,
      showMenu: false,
    };
  },
  methods: {
    ...mapActions(['getSiteData']),
    ...mapActions({ isLogInAction: 'isLogIn' }),

    navigateTo(componentName, eligibilityData) {
      this.currentComponent = componentName;
      this.eligibilityData = eligibilityData;
      this.scrollToTop();
    },
    async Logout() {
      console.log('Logout');
      console.log(this.currentComponent);
      console.log(this.dLNumber);
      if (this.currentComponent === 'SummaryPage') {
        console.log(this.slotId);
        if (this.slotId > 0) {
          try {
            const response = await scApi.ReleaseBookingSlot(this.slotId, this.dLNumber);
            console.log(response);
          } catch (error) {
            console.log(error);
          } finally {
            console.log('Inside releaseBookingSlot finally');
          }
        }
      }
      this.isLogInAction({ value: false });
      SessionState.ClearSession();
      this.currentComponent = 'LoginPage';
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  computed: {
    ...mapGetters(['isLogIn']),
    ...mapGetters(['sessionTimeout']),
    ...mapGetters('userInfo', ['dLNumber']),
    ...mapGetters('bookingDetails', ['slotId']),
    SessionIdleTimeout() {
      return this.sessionTimeout > 0
        ? this.sessionTimeout
        : 20;
    },
    SessionTimeoutWarning() {
      return 'Are you still there?  You will be automatically logged out in ## seconds.';
    },
  },
  async mounted() {
    await this.getSiteData();
  },
};
</script>

<style>
  @import "./assets/css/publicwebsite.css";
</style>

<style scoped>
  .appTitle {
    margin-left: 15px;
  }
  .headerBackground {
    background-image: url('~@/assets/bg-headerDefault.svg');
  }
  .btn-logout{
    height: 35px !important;
    max-width: 150px !important;
  }
</style>
